"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagesCollectionStore = exports.MessageStoreFactory = void 0;
const DEFAULT_MAX_STORED_MESSAGES = 30;
const DEFAULT_MAX_STORED_MESSAGE_COLLECTIONS = 10;
const localStorageKey = 'activityFeedV2_messages';
class MessageStoreFactory {
    constructor(store = {}, maxStoredMessages = DEFAULT_MAX_STORED_MESSAGES) {
        this.store = store;
        this.maxStoredMessages = maxStoredMessages;
        this.store = store;
        this.maxStoredMessages = maxStoredMessages;
    }
    get size() {
        return Object.keys(this.store).length;
    }
    getOldestContent() {
        const sortedMessages = Array.from(Object.values(this.store)).sort((a, b) => a.timestamp - b.timestamp);
        return sortedMessages[0];
    }
    deleteOldContentIfExceedsSizeLimit() {
        while (this.size > this.maxStoredMessages) {
            const oldestMessage = this.getOldestContent();
            if (oldestMessage) {
                this.remove(oldestMessage.id);
            }
        }
    }
    save(id, content) {
        const timestamp = Date.now();
        const storedContent = this.store[id];
        const newContent = {
            id,
            content,
            timestamp,
        };
        this.store[id] = newContent;
        if (!storedContent) {
            this.deleteOldContentIfExceedsSizeLimit();
        }
        return newContent;
    }
    remove(id) {
        delete this.store[id];
    }
}
exports.MessageStoreFactory = MessageStoreFactory;
class MessagesCollectionStore extends MessageStoreFactory {
    constructor() {
        const storedMessages = localStorage.getItem(localStorageKey);
        let collections = {};
        if (storedMessages) {
            collections = JSON.parse(storedMessages);
            Object.values(collections).forEach((collection) => {
                if (collection.content) {
                    const messages = collection.content.store;
                    const messageStore = new MessageStoreFactory(messages);
                    collection.content = messageStore;
                }
            });
        }
        super(collections, DEFAULT_MAX_STORED_MESSAGE_COLLECTIONS);
    }
    getMessage({ collectionID, messageID, }) {
        return this.store[collectionID]?.content.store[messageID];
    }
    saveMessageToCollection({ collectionID, messageID, message }) {
        let collection = this.store[collectionID]?.content;
        if (!collection) {
            collection = new MessageStoreFactory();
        }
        const content = collection.save(messageID, message);
        super.save(collectionID, collection);
        this.updateLocalStorage();
        return content;
    }
    removeMessageFromCollection({ collectionID, messageID }) {
        const collection = this.store[collectionID]?.content;
        if (collection) {
            collection.remove(messageID);
        }
        this.updateLocalStorage();
    }
    remove(id) {
        super.remove(id);
        this.updateLocalStorage();
    }
    updateLocalStorage() {
        localStorage.setItem(localStorageKey, JSON.stringify(this.store));
    }
}
exports.MessagesCollectionStore = MessagesCollectionStore;
//# sourceMappingURL=MessagesCollectionStore.js.map